import React, { Component } from 'react';
import LikeIcon from './LikeIcon';
import PinIcon from './PinIcon';
import TrashIcon from './TrashIcon';
import CommentIcon from './CommentIcon';
import './Icon.css';

export const TYPE_LIKE = 'like';
export const TYPE_PIN = 'pin';
export const TYPE_TRASH = 'trash';
export const TYPE_COMMENT = 'comment';

const TYPES = {
  [TYPE_LIKE]: (filled, name, disabled) => {
    return <LikeIcon filled={filled} name={name} disabled={disabled} />;
  },
  [TYPE_PIN]: (filled, name, disabled) => {
    return <PinIcon filled={filled} size={name} disabled={disabled} />;
  },
  [TYPE_TRASH]: (filled, name, disabled) => {
    return <TrashIcon filled={filled} name={name} disabled={disabled} />;
  },
  [TYPE_COMMENT]: (filled, name, disabled) => {
    return <CommentIcon filled={filled} size={name} disabled={disabled} />;
  }
};

class Icon extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showFilled: this.props.filled
    };
  }

  componentWillReceiveProps(nextProps) {
    const { filled } = nextProps;

    if (filled !== this.props.filled) {
      this.setState({ showFilled: filled });
    }
  }

  render() {
    const { type, name, disabled, onClick, filled, label, count } = this.props;

    const classes = [
      'icon',
      'icon-' + type,
      disabled && 'icon-disabled',
      onClick && 'icon-button',
      onClick && type + '-button'
    ]
      .filter(v => !!v)
      .join(' ');

    const enter = () => {
      this.setState({ showFilled: !filled });
    };
    const leave = () => {
      this.setState({ showFilled: filled });
    };

    return (
      <span
        className={classes}
        onClick={onClick}
        onMouseEnter={disabled || !onClick ? undefined : enter}
        onMouseLeave={disabled || !onClick ? undefined : leave}
      >
        <span className="icon-image">
          {TYPES[type](this.state.showFilled, name, disabled)}
        </span>
        {(label || count > 0) && (
          <span className="icon-label">{label || count}</span>
        )}
      </span>
    );
  }
}

export default Icon;



// WEBPACK FOOTER //
// ./src/components/Icon/index.js